import React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";

const CustomDayPickerInput  = (props: any) => {
    const {inputProps} = props;
    // this background color matches the disabled color of all other inputs
    const newBackgroundColor = inputProps.disabled ? '#e9ecef' : '';

    return (
        <DayPickerInput
            {...props}
            inputProps={{ readOnly: true, disabled: inputProps.disabled, style: {...inputProps.style, backgroundColor: newBackgroundColor}}}
        />
    );
}

export default CustomDayPickerInput;